import { DimensionUnit, WeightUnit } from '@prisma/client';

export const METERS_TO_MILES = 0.000621371;
// We export here so we don't have to import full types pkg into the api
export type Units = {
  weightUnit: WeightUnit;
  dimensionUnit: DimensionUnit;
};
